import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/common-resource';

const validPhase = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}/${branchId}/valid-phase`);
};

export default {
	validPhase,
};
